import React from 'react'
import styles from './AuthView.module.css'
import AuthForm from '../../components/auth/AuthForm.tsx'

const AuthView: React.FC = () => {
  return (
    <>
      <header className="w-full flex flex-row bg-primary items-center justify-between max-w-screen-md mx-auto py-5 px-5 mt-auto">
        <div className="flex mx-auto">
          <img src="/img/appLogo.svg" alt="appLogo" className={styles.appLogo} />
        </div>
      </header>

      <div
        className={`${styles.wrapper} p-5 max-w-screen-md mx-0 sm:mx-auto md:mx-auto lg:mx-auto flex flex-col mt-auto h-[80%]`}
      >
        <AuthForm />

        <div className="text-white text-center mt-auto">
          <a href="tel:+79370072496">
            Техническая поддержка&nbsp;
            <i className={`far fa-phone`}></i>
          </a>
        </div>
      </div>
    </>
  )
}

export default AuthView
